import { CRBTUICSSStyle, CRBTUICSSStyleImpl } from '../home/crbt/crbtuicss';

export interface MyAccountCSSStyle extends CRBTUICSSStyle
{
    getRowDivCSSStyle(): object;
    getInnerWrapperCSSStyle():object;
    getInputWrapperCSSStyle():object;
    getInputDiv1CSSStyle():object;
    getInputDiv2CSSStyle():object;
    getCategoriesListDivCSSStyle():object;
    getButtonDivCSSStyle():object;
    getEditButtonDivCSSStyle():object;
    getCancelButtonDivCSSStyle():object;
}

export class MyAccountCSSStyleImpl extends CRBTUICSSStyleImpl implements MyAccountCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            display: "flex",
            justifyContent: "center",
            flexFlow: "row wrap",
            backgroundSize: "cover",
            // margin:'0px 0px 0px 0px' old
            // marginTop:"75px"
        };
    }
    getInnerWrapperCSSStyle():object
    {
        return{
            height:'100%'
        };
    }
    getInputWrapperCSSStyle():object
    {
        return{
            height:'30px',justifyContents:'flex-starting'
        };
    }

    getInputDiv1CSSStyle():object
    {
        return{
            display:"inline-block",
            height:'40px',
            marginRight:'0px',
            marginBottom:'30px'
        };
    }
    
    getInputDiv2CSSStyle():object
    {
        return{
            display:"inline-block",
            height:'40px',
        };
    }

    getCategoriesListDivCSSStyle():object
    {
        return{
            marginTop:'50px'
        };
    }

    getButtonDivCSSStyle():object
    {
        return{
           
        };
    }
    getEditButtonDivCSSStyle():object
    {
        return{
           
        };
    }
    getCancelButtonDivCSSStyle():object
    {
        return{
            
        };
    }
    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "15px",
            display: "flex",
            position: "relative",
            flexDirection: "row",
            flexFlow: "row wrap",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/myaccount/myaccountcss.tsx